import { NgModule, } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';
import { FlexLayoutModule, } from '@angular/flex-layout';
import { TranslatePipe } from './pipes/translate.pipe';
import {
  CovalentDataTableModule, CovalentMediaModule, CovalentLoadingModule,
  CovalentNotificationsModule, CovalentLayoutModule, CovalentMenuModule,
  CovalentPagingModule, CovalentSearchModule, CovalentStepsModule,
  CovalentCommonModule, CovalentDialogsModule,
} from '@covalent/core';
import {
  MdButtonModule, MdCardModule, MdIconModule,
  MdListModule, MdMenuModule, MdTooltipModule,
  MdSlideToggleModule, MdInputModule, MdAutocompleteModule, MdCheckboxModule,
  MdToolbarModule, MdSnackBarModule, MdSidenavModule,
  MdTabsModule, MdSelectModule,
} from '@angular/material';
import { NgxChartsModule, } from '@swimlane/ngx-charts';
import { DateRangeDialogComponent } from './dialogs/date-range-dialog/date-range-dialog.component';
import { SelectSimilarPieceComponent } from './dialogs/select-similar-piece/select-similar-piece.component';
import { DepositChequeDialogComponent } from './dialogs/deposit-cheque-dialog/deposit-cheque-dialog.component';
import { NewAdvanceDialogComponent } from './dialogs/new-advance-dialog/new-advance-dialog.component';
import { NewCreditDialogComponent } from './dialogs/new-credit-dialog/new-credit-dialog.component';
import { DateSelectDialogComponent } from './dialogs/date-select-dialog/date-select-dialog.component';
import { NewInvoiceDialogComponent } from './dialogs/new-invoice-dialog/new-invoice-dialog.component';
import { InvoiceDetailsDialogComponent } from './dialogs/invoice-details-dialog/invoice-details-dialog.component';
import { DateAndProductSelectDialogComponent } from './dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component';
import { AppModule } from 'app/app.module';
import { CustomerAutocompleteComponent } from './components/customer-autocomplete/customer-autocomplete.component';


const FLEX_LAYOUT_MODULES: any[] = [
  FlexLayoutModule,
];

const ANGULAR_MODULES: any[] = [
  FormsModule, ReactiveFormsModule,
];

const MATERIAL_MODULES: any[] = [
  MdButtonModule, MdCardModule, MdIconModule,
  MdListModule, MdMenuModule, MdTooltipModule,
  MdSlideToggleModule, MdInputModule, MdAutocompleteModule, MdCheckboxModule,
  MdToolbarModule, MdSnackBarModule, MdSidenavModule,
  MdTabsModule, MdSelectModule,
];

const COVALENT_MODULES: any[] = [
  CovalentDataTableModule, CovalentMediaModule, CovalentLoadingModule,
  CovalentNotificationsModule, CovalentLayoutModule, CovalentMenuModule,
  CovalentPagingModule, CovalentSearchModule, CovalentStepsModule,
  CovalentCommonModule, CovalentDialogsModule,
];

const CHART_MODULES: any[] = [
  NgxChartsModule,
];

@NgModule({
  imports: [
    CommonModule,
    ANGULAR_MODULES,
    MATERIAL_MODULES,
    COVALENT_MODULES,
    CHART_MODULES,
    FLEX_LAYOUT_MODULES,
    //AppModule
  ],
  declarations: [
    DateRangeDialogComponent,
    DateSelectDialogComponent,
    SelectSimilarPieceComponent,
    DepositChequeDialogComponent,
    NewAdvanceDialogComponent,
    NewCreditDialogComponent,
    NewInvoiceDialogComponent,
    InvoiceDetailsDialogComponent,
    DateAndProductSelectDialogComponent,
    CustomerAutocompleteComponent,
    //TranslatePipe,
  ],
  exports: [
    ANGULAR_MODULES,
    MATERIAL_MODULES,
    COVALENT_MODULES,
    CHART_MODULES,
    FLEX_LAYOUT_MODULES,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/shared.module.ts